import {AddFundsButton} from '#/components/add-funds/add-funds-button.tsx';
import {MenuButton} from '#/components/buttons/menu-button';
import {FeedbackButton} from '#/components/feedback/feedback-floating-button';
import {HeaderSearchButton, HeaderSearchCloseButton} from '#/components/header/header-atoms';
import HeaderSearchBar from '#/components/header/header-search-bar';
import {ShareLandLogoLink} from '#/components/header/share-land-logo-link';
import {WalletInfo} from '#/components/header/wallet-info';
import environment from '#/environment/environment';
import {FunctionComponent} from 'react';
import {useToggle} from 'react-use';
import {Land, UnlistedLand} from 'shareland-common';

type HeaderProps = {onSearch: (land: Land | UnlistedLand) => void};

export const Header: FunctionComponent<HeaderProps> = ({onSearch}) => {
  const [isSearchOpen, toggleIsSearchOpen] = useToggle(false);

  return (
    <header className={'h-header w-full bg-grayblue px-5 py-3'}>
      {isSearchOpen ? (
        <div className='flex h-full gap-3'>
          <HeaderSearchBar autoFocus className='grow' onSearch={onSearch} onBlur={toggleIsSearchOpen} />
          <HeaderSearchCloseButton onClick={toggleIsSearchOpen} />
        </div>
      ) : (
        <div className='w-full h-full flex justify-between items-center gap-4 max-w-screen-3xl mx-auto'>
          <div className='grow flex h-full items-center gap-4'>
            <MenuButton mode='open' />
            <ShareLandLogoLink />
            <HeaderSearchBar className='hidden lg:block grow max-w-searchBar' onSearch={onSearch} />
            <HeaderSearchButton className='lg:hidden' onClick={toggleIsSearchOpen} />
            <FeedbackButton className='hidden lg:flex' />
          </div>

          <div className='flex h-full items-center gap-3'>
            {environment.isWaitlistNet && <AddFundsButton className='hidden lg:flex' />}
            <WalletInfo />
          </div>
        </div>
      )}
    </header>
  );
};
